import shipvistaAPI from "./shipvistaAPI";

export const verifyReferralCodeService = (_refCode: string) => {
  return shipvistaAPI.get(
    `/register/verifyReferralCode?referralCode=${_refCode}`
  );
};

export const processReferralCodeService = (_refCode: string) => {
  // this will add a cookie on the backend if the cookie already doesn't exist and begin tracking the user
  // return Axios.post(`${SERVER_URL}/api/register/processReferralCode?referralCode=${_refCode}`, { ...getAxiosConfig(), withCredentials: true, })
  // axios seems to be dropping all cookies from response
  return shipvistaAPI.post(
    `/register/processReferralCode?referralCode=${_refCode}`
  );
};
